import React, { memo } from 'react';
import DynamicComponent, { FeedType } from '../general-components/dynamic-component';

type MediaSelectorProps = {
    type: FeedType;
    [key: string]: any;
};

const MediaSelector = (
    { type, ...props }: MediaSelectorProps
) => <DynamicComponent props={{ ...props }} type={type}>
    <></>
</DynamicComponent>;

export default memo(MediaSelector);
